import {h, Fragment} from "preact"
import { useEffect } from 'preact/hooks';
import { useActions, useAppState } from '@nosto/preact';

const parseInteger = (value) =>
    value && !Number.isNaN(value) ? Number.parseInt(`${value}`) : 0;

export default () => {
    const { query, response } = useAppState();
    const { updateSearch } = useActions();

    const from = parseInteger(query.products?.from);
    const size = parseInteger(query.products?.size); // Change to query.products?.size
    const total = parseInteger(response.products.total);
    const to = from + size;

    const loadMore = () => {
        const newProductsLoaded = size + 12; // Increase the size by 12
        updateSearch({
            products: {
                size: Math.min(newProductsLoaded, total)
            },
        });
    };

    const handleLoadMore = () => {
        loadMore();
    };

    return (
        <>
            {total >= 24 && (
                <div class="ns-bottom-toolbar ns-d-flex ns-flex-column ns-align-items-center ns-justify-content-center ns-border-box">
                    <button class="ns-load-more-button" onClick={handleLoadMore}>Load More</button>
                </div>
            )}

        </>
    );
};
